// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._v5641xzp{transition:max-height .3s}._1bsb1osq{width:100%}", ""]);
// Exports
module.exports = exports;
